module.exports = __webpack_public_path__ + "static/media/pro2.6427daba.jpg";